import { usePetitionDetailsPageData } from 'src/app/pages/petitionDetails/pageContext';

import type { NormalizedDMsAndLBs } from './types';
import { normalizeDmsAndLBs } from './utils';

type Result = ModelHookResult<{
	dmsAndLBs: NormalizedDMsAndLBs;
	displayViewAllButton: boolean;
	totalDmCount: number;
}>;

export function useDecisionMakerSection(): Result {
	const {
		data: {
			petition: {
				dmsWithLegislativeBodiesConnection: {
					nodes,
					totalCount,
					pageInfo: { hasNextPage },
				},
			},
		},
	} = usePetitionDetailsPageData();

	const dmsAndLBs = normalizeDmsAndLBs(nodes);

	return {
		data: {
			totalDmCount: totalCount,
			dmsAndLBs,
			displayViewAllButton: hasNextPage,
		},
	};
}
